export default "__VITE_ASSET__DwsqRh0___"